module.exports = __webpack_public_path__ + "img/deco.60bbfab5.svg";